import { Grid, MenuItem, TextField, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import React from 'react';

type Props = {
  formik: any;
  slpList: any;
  selectedPatient: any;
  caseMixGroup: any;
  ptOtList: any;
};

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: '250px',
      width: 300,
    },
  },
};

const ntaCaseMixGroup = ['NA', 'NB', 'NC', 'ND', 'NE', 'NF'];

const assessmentTypeList = [
  '5 Day',
  'Interim Payment',
  'Discharge',
  'Quarterly',
  'Annual',
  'Significant Change',
];

const FinalBasicDetailsMdsAssessment = (props: Props) => {
  const { formik, slpList, selectedPatient, caseMixGroup, ptOtList } = props;
  return (
    <>
      <Typography variant="h6">Final Assessment</Typography>
      {/* <Typography variant="subtitle1">Basic Details</Typography> */}

      <Grid
        spacing={3}
        container
      >
        <Grid
          item
          xs={6}
        >
          <DatePicker
            onChange={(newDate) => formik.setFieldValue('finalMds.assessmentDate', newDate)}
            label="Assessment Date"
            value={formik.values?.finalMds?.assessmentDate}
            minDate={new Date(selectedPatient?.eocStartDate || '01-01-1900')}
            format="MM dd, yyyy"
            sx={{
              width: '100%',
              border:
                formik.touched?.finalMds?.assessmentDate && formik.errors?.finalMds?.assessmentDate
                  ? '2px solid red'
                  : '',
              borderRadius:
                formik.touched?.finalMds?.assessmentDate && formik.errors?.finalMds?.assessmentDate
                  ? '10px'
                  : '',
            }}
          />
          {formik.touched?.finalMds?.assessmentDate && formik.errors?.finalMds?.assessmentDate && (
            <Typography
              padding={'0px 16px'}
              color={'red'}
              variant="caption"
            >
              {formik.errors?.finalMds?.assessmentDate}
            </Typography>
          )}
        </Grid>
        <Grid
          item
          xs={6}
        >
          <TextField
            // defaultValue={'COMMERCIAL_INSURANCE'}
            fullWidth
            error={
              !!(
                formik.touched?.finalMds?.assessmentType && formik?.errors?.finalMds?.assessmentType
              )
            }
            helperText={
              formik.touched?.finalMds?.assessmentType &&
              (formik.errors?.finalMds?.assessmentType as any)
            }
            name="finalMds.assessmentType"
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            SelectProps={{
              MenuProps: MenuProps,
            }}
            value={formik.values?.finalMds?.assessmentType}
            label="Assessment Type"
            select
          >
            {assessmentTypeList?.map((list: any) => (
              <MenuItem
                key={list}
                value={list}
              >
                {list}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
      {/* <Typography variant="subtitle1">Case-mix Group - Final</Typography> */}
      <Grid
        spacing={3}
        container
      >
        <Grid
          item
          xs={6}
        >
          <TextField
            defaultValue={'COMMERCIAL_INSURANCE'}
            fullWidth
            error={
              !!(formik.touched?.finalMds?.mdsPtOtGroup && formik.errors?.finalMds?.mdsPtOtGroup)
            }
            helperText={
              formik.touched?.finalMds?.mdsPtOtGroup &&
              (formik.errors?.finalMds?.mdsPtOtGroup as any)
            }
            name="finalMds.mdsPtOtGroup"
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            SelectProps={{
              MenuProps: MenuProps,
            }}
            value={formik.values?.finalMds?.mdsPtOtGroup}
            label="MDS PT-OT Case-mix Group"
            select
          >
            <MenuItem
              key={'Not Applicable'}
              value={'Not Applicable'}
            >
              Not Applicable
            </MenuItem>
            {ptOtList?.map((list: any) => (
              <MenuItem
                key={list}
                value={list}
              >
                {list}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid
          item
          xs={6}
        >
          <TextField
            defaultValue={'COMMERCIAL_INSURANCE'}
            fullWidth
            label="MDS SLP Case-mix Group"
            error={
              !!(formik.touched?.finalMds?.mdsSlpGroup && formik.errors?.finalMds?.mdsSlpGroup)
            }
            helperText={
              formik.touched?.finalMds?.mdsSlpGroup && (formik.errors?.finalMds?.mdsSlpGroup as any)
            }
            SelectProps={{
              MenuProps: MenuProps,
            }}
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            value={formik.values?.finalMds?.mdsSlpGroup}
            name="finalMds.mdsSlpGroup"
            select
          >
            <MenuItem
              key={'Not Applicable'}
              value={'Not Applicable'}
            >
              Not Applicable
            </MenuItem>
            {slpList?.map((list: any) => (
              <MenuItem
                key={list}
                value={list}
              >
                {list}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid
          item
          xs={6}
        >
          <TextField
            defaultValue={'COMMERCIAL_INSURANCE'}
            fullWidth
            label="MDS Nursing Case-mix Group"
            error={
              !!(
                formik.touched?.finalMds?.mdsNursingGroup &&
                formik.errors?.finalMds?.mdsNursingGroup
              )
            }
            helperText={
              formik.touched?.finalMds?.mdsNursingGroup &&
              (formik.errors?.finalMds?.mdsNursingGroup as any)
            }
            name="finalMds.mdsNursingGroup"
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            value={formik.values?.finalMds?.mdsNursingGroup}
            SelectProps={{
              MenuProps: MenuProps,
            }}
            select
          >
            <MenuItem
              key={'Not Applicable'}
              value={'Not Applicable'}
            >
              Not Applicable
            </MenuItem>
            {caseMixGroup?.map((value: any) => (
              <MenuItem
                key={value}
                value={value}
              >
                {value}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid
          item
          xs={6}
        >
          <TextField
            defaultValue={'COMMERCIAL_INSURANCE'}
            fullWidth
            label="MDS NTA Case-mix Group"
            name="finalMds.mdsNtaGroup"
            error={
              !!(formik.touched?.finalMds?.mdsNtaGroup && formik.errors?.finalMds?.mdsNtaGroup)
            }
            helperText={
              formik.touched?.finalMds?.mdsNtaGroup && (formik.errors?.finalMds?.mdsNtaGroup as any)
            }
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            value={formik.values?.finalMds?.mdsNtaGroup}
            select
          >
            <MenuItem
              key={'Not Applicable'}
              value={'Not Applicable'}
            >
              Not Applicable
            </MenuItem>
            {ntaCaseMixGroup?.map((value) => (
              <MenuItem
                key={value}
                value={value}
              >
                {value}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
    </>
  );
};

export default FinalBasicDetailsMdsAssessment;
